import { useLocation, useSearchParams } from "react-router-dom";

// hooks for query params
export function useQueryParams() {
  const location = useLocation();

  // Combine pathname, search, and hash to get the full path
  const fullPath = `${location.pathname}${location.search}${location.hash}`;

  const [searchParams, setSearchParams] = useSearchParams();

  // Convert searchParams → object
  const params = Object.fromEntries([...searchParams]);

  // Convert params object → query string
  const paramsUrl = new URLSearchParams(params).toString();

  const removeParamsFromObject = (removeKeys = []) => {
    const cleaned = { ...params };

    // Remove unwanted keys directly inside the same function
    if (Array.isArray(removeKeys) && removeKeys.length > 0) {
      removeKeys.forEach((key) => {
        delete cleaned[key];
      });
    }

    // Convert back to URL query string
    const cleanedUrl = new URLSearchParams(cleaned).toString();

    return {
      cleanedParams: cleaned,
      cleanedUrl
    };
  };

  return {
    searchParams,
    setSearchParams,
    fullPath,
    params,
    paramsUrl,
    removeParamsFromObject,
    location
  };
}

export function cleanDuplicateQuery(queryString) {
  // Remove leading ? if present
  const qs = queryString.startsWith("?") ? queryString.slice(1) : queryString;
  const seen = new Map();

  // URLSearchParams keeps first occurrence by default, so we need to override manually
  qs.split("&").forEach((pair) => {
    const [key, value] = pair.split("=");
    if (key) {
      seen.set(key, value);
    }
  });

  const cleaned = new URLSearchParams();
  for (const [key, value] of seen.entries()) {
    cleaned.set(key, value);
  }

  return "?" + cleaned.toString();
}
